<template>
    <div class="nevs-content">
        <NevsCard>
            <NevsTextField style="float: left;" :label="$LANG.Get('labels.filter') + ':'" :width="'300px'" v-model="roomsData.filters.name"></NevsTextField>
            <NevsCheckbox style="float: left; margin-left: 15px;" :width="'auto'" :reserveHeights="true" v-model="roomsData.filters.show_inactive" :label="$LANG.Get('labels.showInactiveRooms')"></NevsCheckbox>
            <span style="float: right;"><NevsButton class="primary" @click="addRoom"><i class="fa-solid fa-plus"></i> {{ $LANG.Get('buttons.addRoom') }}</NevsButton></span>
            <div style="clear: both;"></div>

            <NevsTinyGrid :columns="gridColumns" :records="roomsData.records" :actions="gridActions"
                          :empty-text="$LANG.Get('labels.noRooms')" :is-inactive="(room) => !room.active"
                          @action="gridAction"></NevsTinyGrid>
        </NevsCard>
        <ModalEditRoom :show="editRoomModal.show" :room="editRoomModal.room" @done="editRoomDone"></ModalEditRoom>
    </div>
</template>

<script>

import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsTinyGrid from "@/components/nevs/NevsTinyGrid.vue";
import ModalEditRoom from "@/components/modals/ModalEditRoom.vue";

export default {
    name: "ModuleRooms",
    components: {NevsTinyGrid, ModalEditRoom, NevsCheckbox, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            roomsData: {
                filters: {
                    name: '',
                    show_inactive: false
                },
                records: [],
                filterTimer: null
            },
            editRoomModal: {
                show: false,
                room: null
            }
        }
    },
    computed: {
        gridColumns() {
            return [
                {key: 'name', label: this.$LANG.Get('fields.name')},
                {key: 'capacity', label: this.$LANG.Get('fields.capacity'), align: 'right'}
            ];
        },
        gridActions() {
            return [
                {name: 'edit', icon: 'fa-solid fa-pen', tooltip: this.$LANG.Get('tooltips.edit')}
            ];
        }
    },
    watch: {
        'roomsData.filters.name': {
            handler() {
                if (this.roomsData.filterTimer !== null) {
                    clearTimeout(this.roomsData.filterTimer);
                }
                let vm = this;
                this.roomsData.filterTimer = setTimeout(function () {
                    vm.reloadRooms();
                }, 500);
            },
            deep: true
        },
        'roomsData.filters.show_inactive': {
            handler() {
                this.reloadRooms();
            }
        }
    },
    methods: {
        gridAction(name, room) {
            if (name === 'edit') {
                this.editRoom(room);
            }
        },
        addRoom() {
            this.editRoomModal.room = null;
            this.editRoomModal.show = true;
        },
        editRoom(room) {
            this.editRoomModal.room = room;
            this.editRoomModal.show = true;
        },
        editRoomDone(success) {
            this.editRoomModal.show = false;
            this.editRoomModal.room = null;
            if (success) {
                this.reloadRooms();
            }
        },
        reloadRooms() {
            let vm = this;
            let request = {
                filters: this.roomsData.filters
            };
            this.$API.APICall('get', 'rooms', request, (data, success) => {
                if (success) {
                    vm.roomsData.records = data.records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'training');
        this.$store.commit('selectSubMenu', 'rooms');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.training'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.rooms'),
                link: null
            }
        ]);
        this.reloadRooms();
    }
}
</script>
